// src/features/search/searchSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchApi } from 'Config/fetchApi';
import { dataURItoBlob } from 'Helper';

// Thunk untuk melakukan pencarian gambar
export const searchImage = createAsyncThunk(
  'search/searchImage',
  async (image, { rejectWithValue }) => {
    try {
      const api = fetchApi(); // Menggunakan fetchApi untuk konsistensi
      const imageBlob = dataURItoBlob(image); // Mengubah Data URI menjadi Blob
      const formData = new FormData();
      formData.append("file", imageBlob); // Menambahkan file gambar ke form data
      formData.append("fetch_limit", 10); // Batasi hasil pencarian hingga 10 hasil

      // Melakukan request POST ke API
      const response = await api.post('/person/identify-one?fetch_limit=1', formData);

      const resp = response?.data?.[0];
      const result = resp
        ? {
            ...resp?.personDetail,
            similarity: +(resp?.similarity * 100).toFixed(0),
            imageCrop: image,
          }
        : null;

      return result;
    } catch (error) {
      console.error("Gagal mengirim request:", error);
      return rejectWithValue(error.message);
    }
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    data: [],
    isSearching: false,
    error: null,
  },
  reducers: {
    setSearchData: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchImage.pending, (state) => {
        state.isSearching = true;
        state.data = []; // Kosongkan data sebelumnya
      })
      .addCase(searchImage.fulfilled, (state, action) => {
        state.isSearching = false;
        state.data = action.payload ? [action.payload] : [];
      })
      .addCase(searchImage.rejected, (state, action) => {
        state.isSearching = false;
        state.error = action.payload;
      });
  },
});

// Export reducer dan action
export const { setSearchData } = searchSlice.actions;
export default searchSlice.reducer;
